import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { authHeader, baseUrl } from '../../../utils'
import AutocompleteSelect from '../../elements/form/AutocompleteSelect'
import Loader from '../../elements/Loader'

const AssignElectiveSubject = ({student, close, reload}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true);
    const [studentElectives, setStudentElectives] = useState(null)
    const [academicSettings, setAcademicSettings] = useState(null)
    const [selectedSubject, setSelectedSubject] = useState(null)

    
    useEffect(() => {
        const headers = authHeader()
        const fetchStudentElectives = async () => {
            try {
                const response = await axios.get(`${baseUrl}/student-electives?student=${student?._id}&studentClass=${student?.class?.class?._id}&expand=subject`, { headers })
                const electives = response.data.data.electives
                setStudentElectives(Array.isArray(electives) ? electives : [])
            } catch (error) {
                console.error(error);
                dispatch({
                    type: 'ERROR',
                    error,
                });
                setLoading(false)
            }
        }

        const fetchAcademicSettings = async () => {
            try{
                setLoading(true)
                // const headers = authHeader()
                const response = await axios.get(`${baseUrl}/academic-settings?expand=electiveSubjects.subject,electiveSubjects.classes`, { headers })
                setAcademicSettings(response.data.data.academicSettings[0])
                await fetchStudentElectives()

            } catch(error){
                console.log('error fetching academic settings: ', error)
                dispatch({
                    type: 'ERROR',
                    error,
                });
            } finally {
                setLoading(false)
            }
       }
       fetchAcademicSettings()

        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const assignedSubjectIds = new Set(
        studentElectives?.map(assignment => assignment.subject?._id).filter(Boolean) || []
    )

    const availableElectives = academicSettings?.electiveSubjects?.filter(subject => {
        const isOfferedForStudentClass = subject.classes?.some(
            electiveClass => electiveClass._id === student?.class?.class?._id
        )
        const isAssigned = assignedSubjectIds.has(subject.subject?._id)
        return isOfferedForStudentClass && !isAssigned
    }) || []

    const pushElectiveAssignment = async () => {
        try {
            const headers = authHeader()
            const payload = {
                student: student?._id,
                subject: selectedSubject
            }
            await axios.post(`${baseUrl}/student-electives`, payload, { headers })
            dispatch({
                type: 'SET_SUCCESS',
                payload: 'Elective subject assigned successfully'
            })
            reload()
            setTimeout(() => {
                close()
            }, 50);
        } catch (error) {
            console.error(error);
            dispatch({
                type: 'ERROR',
                error,
            });
        }
    }

    return (
        <>
            {
                loading ?
                    <Loader />
                :
                <div className="w-full">
                    <p className='text-sm text-gray-500 '>Select an elective below to assign to {student?.fullName} for study</p>
                    {!academicSettings?.electiveSubjects || academicSettings?.electiveSubjects.length === 0 ?
                        <p className='text-sm text-gray-500 mt-4'>No elective subjects have been created yet. Please create an elective subject first.</p>
                    :
                        <div className='w-full mt-4'>
                            <AutocompleteSelect
                                selectOptions = {availableElectives?.map(subject => ({ ...subject, label: subject.subject.name })) || []}
                                inputLabel = "Select an elective subject"
                                requiredField={true}
                                titleField = "label"
                                displayImage = {false}
                                imageField = ""
                                placeholderText={`Select an elective subject`}
                                fieldId = {`class-parent`}
                                preSelected={''}
                                preSelectedLabel='_id'
                                hasError = {false}
                                returnFieldValue={(value)=>{setSelectedSubject(value.subject._id)}}
                            />
                        </div> 
                    }

                    <div className="mt-4 flex flex-row-reverse gap-x-4">
                        <ModalActionButton
                            buttonLabel={`Add Elective Subject`}
                            buttonAction={pushElectiveAssignment}
                            processing={false}
                        />

                        <button
                            type="button"
                            className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-xl duration-200 transition hover:bg-opacity-10 hover:bg-secondary focus:outline-none"
                            onClick={close}
                        >
                            Cancel
                        </button>
                    
                    </div>
                </div>

            }
        </>
    )
}

export default AssignElectiveSubject